import { AuditModel } from "@core/services/api.service";


export class LoadAuditHistoryAction {
    constructor(public entityId: number | undefined) { }
    static readonly type = '[AuditHistory] Load AuditHistory';
}

export class LoadAuditHistorySuccessAction {
    static readonly type = '[AuditsHistory] Load AuditHistory Success';

    constructor(public payload: { audits: AuditModel[] }) { }
}

export class LoadAuditHistoryFailAction {
    static readonly type = '[AuditHistory] Load AuditHistory Fail';
}

export class LoadAuditsHistoryAction {
    constructor(public entityId: number | undefined) { }
    static readonly type = '[AuditsHistory] Load AuditsHistory';
}

export class LoadAuditsHistorySuccessAction {
    static readonly type = '[AuditsHistory] Load AuditsHistory Success';

    constructor(public payload: { audits: AuditModel[] }) { }
}

export class LoadAuditsHistoryFailAction {
    static readonly type = '[AuditsHistory] Load AuditsHistory Fail';
}
